import React, { useEffect, useState } from "react";
import { Radio, Image, ConfigProvider } from "antd";
import { CloseOutlined, CheckOutlined, UserOutlined } from "@ant-design/icons";
import swal from "sweetalert";

const ProfilePhotoMatch = ({
  interviewMode,
  setInterviewMode,
  candidatePhoto,
  setPhotoMatch,
  photoMatch,
  setInterviewStatus,
  candidatePhotoPresent,
  interview,
  concent,
  setConcent,
  space,
  canTakeInterview,
}) => {
  useEffect(() => {
    if (!interview) return;
    if (interview?.modeOfInterview) {
      setInterviewMode(interview?.modeOfInterview);
      if (interview?.modeOfInterview !== "Telephonic") {
        if (
          interview?.profileImageMatchStatus === false ||
          interview?.profileImageMatchStatus === true
        ) {
          setPhotoMatch(interview?.profileImageMatchStatus);
          setConcent(true);
        }
      }
    }
  }, [interview]);

  const role = canTakeInterview !== undefined ? !canTakeInterview : localStorage.getItem("user.role") !== "interviewer";

  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center">
        <label
          style={{ fontSize: "0.8rem", width: `${space}px` }}
          htmlFor="interviewer"
        >
          Interview Type:<span style={{ color: "red" }}>*</span>
        </label>
        <div className="mb-0" style={{ flex: "1 1" }}>
          <ConfigProvider
            theme={{
              components: {
                Radio: {
                  buttonSolidCheckedActiveBg: "#000000",
                  buttonSolidCheckedBg: "#000000",
                },
              },
            }}
          >
            <Radio.Group
              buttonStyle="solid"
              style={{ marginBottom: 5 }}
              value={interviewMode}
              onChange={(e) => {
                setConcent(false);
                setPhotoMatch(null);
                setConcent(false);
                if (e.target.value === "Telephonic") {
                  setInterviewStatus("Selected");
                } else {
                  if (!candidatePhotoPresent) {
                    return swal({
                      icon: "error",
                      content: {
                        element: "div",
                        attributes: {
                          innerHTML: `
                          <p style="text-align:center">Candidate has not uploaded a photo. Please request the candidate to upload one for verification.</p>       
                          `,
                        },
                      },
                    });
                  }
                }
                setInterviewMode(e.target.value);
              }}
              disabled={role}
            >
              <Radio.Button
                style={{ fontSize: "12px", padding: "0 10px" }}
                value="Telephonic"
              >
                Telephonic
              </Radio.Button>
              <Radio.Button
                style={{ fontSize: "12px", padding: "0 10px" }}
                value="Video Call"
              >
                Video Call
              </Radio.Button>
              <Radio.Button
                style={{ fontSize: "12px", padding: "0 10px" }}
                value="In Person"
              >
                In Person
              </Radio.Button>
            </Radio.Group>
          </ConfigProvider>
        </div>
      </div>
      {interviewMode !== "Telephonic" && (
        <div className="d-flex w-100 my-2" style={{ gap: "0.2rem" }}>
          <div style={{ width: "159px" }} className="d-flex align-items-center">
            {candidatePhoto ? (
              <Image style={{ height: "130px" }} src={candidatePhoto || ""} />
            ) : (
              <div
                style={{
                  width: "100px",
                  height: "100px",
                  border: "1px solid black",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <UserOutlined style={{ fontSize: "4rem" }} />
              </div>
            )}
          </div>
          <div
            className="d-flex flex-column"
            style={{ width: "70%", gap: "0.5rem" }}
          >
            <div>
              <button
                style={{ maxWidth: "210px", width: "100%", textAlign: "left" }}
                className={`__btn px-3 text-white rounded font-weight-bold ${
                  photoMatch == null
                    ? "__initial_accepted"
                    : photoMatch
                    ? "__accepted"
                    : "__initial_accepted"
                }`}
                onClick={(e) => {
                  if (!candidatePhotoPresent) {
                    return swal({
                      icon: "error",
                      content: {
                        element: "div",
                        attributes: {
                          innerHTML: `
            <p style="text-align:center">Candidate has not uploaded a photo. Please request the candidate to upload one for verification.</p>       
          `,
                        },
                      },
                    });
                  }
                  setPhotoMatch(true);
                  setInterviewStatus("Selected");
                }}
                disabled={role}
              >
                {" "}
                <CheckOutlined
                  style={{
                    borderRadius: "50%",
                    padding: 2,
                    marginRight: "5px",
                  }}
                  className={
                    photoMatch === null
                      ? "__initial_accepted_icon"
                      : photoMatch
                      ? "__accepted_icon"
                      : "__initial_accepted_icon"
                  }
                />
                Photo Matched
              </button>
            </div>
            <div>
              <button
                style={{ maxWidth: "210px", width: "100%", textAlign: "left" }}
                className={`__btn px-3 text-white rounded font-weight-bold ${
                  photoMatch == null
                    ? "__initial_rejected"
                    : !photoMatch
                    ? "__rejected"
                    : "__initial_rejected"
                }`}
                disabled={role}
                onClick={(e) => {
                  setPhotoMatch(false);
                  setConcent(false);
                  setInterviewStatus("Suspicious");
                }}
              >
                <CloseOutlined
                  style={{
                    borderRadius: "50%",
                    padding: 2,
                    marginRight: "5px",
                  }}
                  className={
                    photoMatch === null
                      ? "__initial_rejected_icon"
                      : !photoMatch
                      ? "__rejected_icon"
                      : "__initial_rejected_icon"
                  }
                />
                Photo Not Matched
              </button>
            </div>
            {photoMatch && (
              <div
                className="d-flex align-items-start"
                style={{ gap: "0.3rem" }}
              >
                <input
                  checked={concent}
                  onChange={(e) => {
                    setConcent(e.target.checked);
                  }}
                  id="concent"
                  type="checkbox"
                  style={{ marginTop: "4px" }}
                  disabled={!photoMatch || role}
                />
                <label style={{ fontSize: "0.7rem" }} htmlFor="concent">
                  I confirm that the person interviewed by me matches the photo
                  submitted in the candidate application.
                </label>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePhotoMatch;
